<template>
  <PageContainer>
    <!-- 商品总数 -->
    <div class="product-result">
      <span v-if="total === -1">Searching...</span>
      <span v-else>Smart Picks, Just for You 👋</span>
    </div>
    <Product :product-list="productList" />
  </PageContainer>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue'
import { useStore } from 'vuex'
import Product from '@/components/Product/index.vue'
import { gaAnalytics } from '@/utils/utils'
import { fetchData } from '@/utils/fetch'
import { productInitList } from '@/common/productInitData'
import { useRoute } from 'vue-router'
import { useUserStore } from '@/pinia/user'
import { PageContainer } from '@/components/PageLayout'

const store = useStore()
const route = useRoute()
const user = useUserStore()

const productList = ref([])
const total = ref(0)
let loadingMore = false

const searchProductList = async () => {
  store.commit('setInitSkeleton', true)
  const queryData = '/appb/b2b/product/recommend/productListV2?itemNumber=50'
  const { data, code } = await fetchData(queryData, { method: 'get' })
  if (code === 200 && data.length !== 0) {
    productList.value = data.map((v) => {
      return {
        ...v,
        priceInfo: { price: v.priceInfo.price }
      }
    })
    total.value = data.length
  } else {
    productList.value = productInitList
    total.value = productInitList.length
  }
  store.commit('setInitSkeleton', false)
}

onMounted(() => {
  gaAnalytics('p_home_page_view', 'p_home_page_view', {
    bdUserId: user.userInfo.uid
  })
  searchProductList()
  window.addEventListener('scroll', layoutOnScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', layoutOnScroll)
})

const layoutOnScroll = () => {
  const pageScrollY = window.scrollY
  const scrollHeight = document.documentElement.scrollHeight
  const clientHeight = window.innerHeight

  // 判断当前位置加 75px 是否大于等于最大滚动位置
  if (route.path === '/') {
    if (pageScrollY + 75 >= scrollHeight - clientHeight) {
      loadMore()
    }
  }
}

const loadMore = async () => {
  if (loadingMore) return
  loadingMore = true
  store.commit('setLoadMoreSleleton', true)
  try {
    const { data, code } = await fetchData('/appb/b2b/product/recommend/productListV2?itemNumber=50')
    if (code === 200 && data.length !== 0) {
      const newData = data.map((v) => {
        return {
          ...v,
          priceInfo: { price: v.priceInfo.price }
        }
      })
      productList.value = [...productList.value, ...newData]
      total.value = data.length
    } else {
      productList.value = productInitList
      total.value = productInitList.length
    }
  } finally {
    loadingMore = false
    store.commit('setLoadMoreSleleton', false)
    store.commit('search/SET_PRE_SEARCH', false)
  }
}

const preSearch = computed(() => store.state.search.preSearch)
watch(preSearch, (value) => {
  if (value) {
    loadMore()
  }
})
</script>

<style lang="less" scoped>
.product-result {
  text-align: left;
  padding: 32px 0 24px;
  font-size: 20px;
  font-family: mon-700;
  color: #232323;
}

.help-center-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 388px;
  margin: 20px auto 0px;
  div:nth-child(1) {
    width: 32px;
    height: 1px;
    background-color: #ebebeb;
  }
  div:nth-child(2) {
    color: #009de0;
    font-size: 12px;
    line-height: 16px;
    font-family: mon-500;
    cursor: pointer;
  }
  div:nth-child(3) {
    width: 32px;
    height: 1px;
    background-color: #ebebeb;
  }
}
</style>
